export function getParameterByName(name) {
    const url = window.location.href;
    return getParameterFromUrl(name, url);
}

export function getParameterFromUrl(name: string, url: string) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function removeParameterByName(name): string {
    const url = window.location.href;
    return removeUrlParameter(url, name);
}

function removeUrlParameter(url, parameter) {
    var urlParts = url.split('?');

    if (urlParts.length >= 2) {
        // Get first part, and remove from array
        var urlBase = urlParts.shift();

        // Join it back up
        var queryString = urlParts.join('?');

        var prefix = encodeURIComponent(parameter) + '=';
        var parts: Array<string> = queryString.split(/[&;]|[#/;]/g);

        // Reverse iteration as may be destructive
        for (var i = parts.length; i-- > 0;) {
            // Idiom for string.startsWith
            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                parts.splice(i, 1);
            }
        }

        var goToSeatmap = false;

        if (parts[parts.length - 1] === "seatmap") {
            parts.pop();
            goToSeatmap = true;
        }

        url = urlBase + '?' + parts.filter(part => part.length > 0).join('&') + (goToSeatmap ? "#/seatmap" : "");
    }

    return url;
}